import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-th-shieldchevron",
  "use": "icon-th-shieldchevron-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-th-shieldchevron\">\n<path d=\"M26 5H6C5.46957 5 4.96086 5.21071 4.58579 5.58579C4.21071 5.96086 4 6.46957 4 7V14.3462C4 25.5475 13.4775 29.2638 15.375 29.895C15.7803 30.0328 16.2197 30.0328 16.625 29.895C18.525 29.2638 28 25.5475 28 14.3462V7C28 6.46957 27.7893 5.96086 27.4142 5.58579C27.0391 5.21071 26.5304 5 26 5ZM16 28C14.8425 27.615 10.5887 25.96 8.01625 21.8125L16 16.22L23.9837 21.8088C21.4137 25.9513 17.1675 27.6063 16 28ZM26 14.3525C26 16.5575 25.58 18.4313 24.91 20.02L16.5737 14.185C16.4056 14.0672 16.2053 14.004 16 14.004C15.7947 14.004 15.5944 14.0672 15.4263 14.185L7.09 20.0163C6.42 18.4275 6 16.5538 6 14.3488V7H26V14.3525Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/th-shieldchevron.svg
// module id = YyVv
// module chunks = 84